import { ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon, EventAvailable as EventAvailableIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, Box, Breadcrumbs, Button, Card, CardActions, Checkbox, Container, Dialog, FormControlLabel, Grid, Hidden, Link, MenuItem, Paper, Radio, RadioGroup, Skeleton, Step, StepLabel, Stepper, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import _ from 'lodash'
import moment from 'moment-timezone'
import React from 'react'
import { Route, Link as RouterLink, Switch, withRouter } from "react-router-dom"
import SharedUtilities from '../../shared/classes/SharedUtilities'
import Utilities from '../classes/Utilities'
import { AppointmentPicker, ClearableTextField, CreditCardFrame, GuestForm, ServiceCard } from '../components'
import { withAppContext } from '../context/AppContextProvider'
import NotFound from './404'

const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

const styles = (theme) => ({
    marginAbove: {
        marginTop: theme.spacing(2),
    },
    accordionHeading: {
        fontSize: theme.typography.pxToRem(15),
    },
    accordionSecondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    accordionColumn: {
        flexBasis: '33.33%',
    },
    cardContent: {
        padding: 0,
    },
    appointmentPickerContainer: props => ({
        // adjust when adding/removing elements around the picker
        [theme.breakpoints.down('md')]: {
            scrollbarColor: '#999 #eee',
            '&::-webkit-scrollbar': {
                width: 12,
                height: 12,
                '&-thumb': {
                    background: '#a6a6a6',
                    borderRadius: 12,
                },
                '&-track': {
                    background: '#eee',
                    borderRadius: 12,
                    border: '1px solid #ccc',
                },
            },
        },
    }),
    guestInfoCard: {
        padding: theme.spacing(2),
    },
    nested: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    noBorderBottom: {
        borderBottom: 0,
        paddingBottom: 0,
    },
    dialogText: {
        padding: theme.spacing(2),
    },
})

class Book extends React.Component {
    state = {
        waits: 1,
        filterTerm: '',
        categories: [],
        services: [],
        employees: [],
        campaignTypes: [],
        requireCampaignType: null,
        bookOutMin: null,
        bookOutMax: null,
        selectedWeek: null,
        hideUnavailableTimes: false,
        date: null,
        time: null,
        guestFormFilled: false,
        guestInfo: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            campaignType: '',
        },
        paymentMethod: this.props.user.isGuest ? 'credit' : null, // hard-coded for guests for now
        paymentCofId: this.props.cart.activeCard ? this.props.cart.activeCard.id : null,
        paymentToken: null,
        paymentExpiry: null,
        paymentLast4: null,
        paymentType: null,
        paymentExtraData: null,
        paymentSaveCard: true,
        note: '',
        submitting: false,
    }

    componentDidMount = async () => {
        this.unlistenHistory = this.props.history.listen(this.handleHistoryChange)

        if (SharedUtilities.urlParamExists('guestInfo')) {
            await this.setState({
                guestInfo: JSON.parse(SharedUtilities.getUrlParam('guestInfo')),
                guestFormFilled: SharedUtilities.getUrlParam('skipGuestInfo') == 'true',
            })
        }

        await this.getServices()

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    componentWillUnmount = () => {
        this.unlistenHistory()
    }

    getServices = async () => {
        await this.setState({
            waits: this.state.waits + 1,
        })

        try {
            const { services, categories, employees, campaignTypes, requireCampaignType, bookOutMin, bookOutMax } = await this.props.socket.send('book', {
                step: 'getServices',
            })

            await this.setState({
                services,
                categories,
                employees,
                campaignTypes,
                requireCampaignType,
                bookOutMin,
                bookOutMax,
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    isSubmittable = (service) => {
        const { user } = this.props
        const { paymentMethod, paymentToken, paymentCofId } = this.state

        // rules for everyone but employees
        if (!user.isEmployee) {
            // payment required in advance
            if (service.service_payment_in_advance > 0) {
                if (!paymentMethod) {
                    return false
                }

                // credit card information not provided
                if (paymentMethod == 'credit' && !paymentToken) {
                    return false
                }

                // card-on-file not chosen
                if (paymentMethod == 'cof' && !paymentCofId) {
                    return false
                }
            }
        }

        return true
    }

    handleHistoryChange = () => {
        this.setState({
            filterTerm: '',
            date: null,
            time: null,
            selectedWeek: null,
            guestFormFilled: false,
            note: '',
        })
    }

    handleHideUnavailableTimes = () => {
        const { hideUnavailableTimes } = this.state

        this.setState({
            hideUnavailableTimes: !hideUnavailableTimes,
        })
    }

    handleGuestFormSubmit = (event) => {
        event.preventDefault()

        document.documentElement.scrollTop = 0

        this.props.messageCompanion({
            notifyEvent: 'pageChange',
        })

        this.setState({
            guestFormFilled: true,
            guestInfo: Utilities.getFormValues(event.target),
        })
    }

    handlePaymentMethodChange = (event) => {
        this.setState({
            paymentMethod: event.target.value,
            paymentToken: null,
            paymentExpiry: null,
            paymentLast4: null,
            paymentType: null,
            paymentExtraData: null,
        })
    }

    handlePaymentCofIdChange = (event) => {
        this.setState({
            paymentCofId: event.target.value,
        })
    }

    handleTokenize = (paymentToken, paymentExpiry, paymentLast4, paymentType, paymentExtraData, paymentSaveCard) => {
        this.setState({
            paymentToken,
            paymentExpiry,
            paymentLast4,
            paymentType,
            paymentExtraData,
            paymentSaveCard,
        })
    }

    handlePaymentChangeCard = () => {
        this.setState({
            paymentToken: null,
            paymentExpiry: null,
            paymentLast4: null,
            paymentType: null,
            paymentExtraData: null,
        })
    }

    handleBook = async (serviceId, employeeId, date, time, guestInfo, note) => {
        const { showMessage, showError, closeSnackbar, remoteUser, userType, messageCompanion, socket, history, paths, embedOptions } = this.props
        const { paymentMethod, paymentCofId, paymentToken, paymentExpiry, paymentLast4, paymentType, paymentExtraData, paymentSaveCard } = this.state

        await this.setState({
            submitting: true,
        })

        try {
            const response = await socket.send('book', {
                step: 'submitBooking',
                guestInfo,
                serviceId,
                employeeId,
                date,
                time,
                localTimeZone,
                note,
                paymentMethod,
                paymentCofId: paymentMethod == 'cof' ? paymentCofId : '',
                paymentToken: paymentMethod == 'credit' ? paymentToken : '',
                paymentExpiry: paymentMethod == 'credit' ? paymentExpiry : '',
                paymentLast4: paymentMethod == 'credit' ? paymentLast4 : '',
                paymentType: paymentMethod == 'credit' ? paymentType : '',
                paymentExtraData: paymentMethod == 'credit' ? paymentExtraData : null,
                paymentSaveCard: paymentMethod == 'credit' ? paymentSaveCard : false,
            })

            await this.setState({
                date: null,
                time: null,
                selectedWeek: null,
                guestFormFilled: false,
                note: '',
            })

            showMessage(response, {
                variant: 'success',
                persist: true,
                // eslint-disable-next-line react/display-name
                action: (key) => <Button onClick={() => { closeSnackbar(key) }}>Dismiss</Button>,
            })

            // in case lead was converted to customer and shouldn't see lead-only services anymore
            await this.getServices()

            if (userType == 'caregiver' && remoteUser) {
                // unchoose remote user automatically
                await socket.send('remoteUsers', {
                    step: 'setRemoteUser',
                    remoteUser: null,
                })
            }

            if (embedOptions.bookingLandingUrl) {
                messageCompanion({
                    navigateAway: embedOptions.bookingLandingUrl,
                })
            }

            history.push(paths.root)

        } catch (err) {
            showError(err)
        }

        await this.setState({
            submitting: false,
        })
    }

    render = () => {
        const { classes, history, match, features, paths, user, cart, fileset, store, messageCompanion, iframeFixes } = this.props
        const { filterTerm, services, categories, employees, campaignTypes, requireCampaignType, bookOutMin, bookOutMax, selectedWeek, hideUnavailableTimes, date, time,
            guestFormFilled, guestInfo, paymentMethod, paymentToken, paymentLast4, paymentCofId, paymentSaveCard, note, submitting, waits } = this.state
        const { path } = match
        const filterPattern = new RegExp("(?=.*?\\b" + filterTerm.split(" ").join(")(?=.*?\\b") + ").*", "i")

        return (
            <Switch>
                {/* root / category list */}
                <Route path={path} exact>
                    <Container maxWidth="md">
                        <Paper className={classes.marginAbove}>
                            <TheStepper activeStep={0} />
                        </Paper>
                        <Grid container justifyContent="space-between" alignItems="flex-end">
                            <Grid className={classes.marginAbove} item xs={12} sm={7} md={9} lg={9}>
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Link component={RouterLink} to={`${path}`} color="textPrimary" underline="hover">
                                        Services
                                    </Link>
                                </Breadcrumbs>
                            </Grid>
                            <Grid item xs={12} sm={5} md={3} lg={3}>
                                <ClearableTextField
                                    id="filter"
                                    name="filter"
                                    label="Filter"
                                    value={filterTerm}
                                    fullWidth
                                    onInput={(event) => { this.setState({ filterTerm: event.target.value }) }}
                                    onClearClick={() => { this.setState({ filterTerm: '' }) }}
                                />
                            </Grid>
                        </Grid>

                        <Box className={classes.marginAbove}>
                            {waits > 0 && Array.from({ length: 5 }, (e, i) => (
                                <Accordion key={i}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography sx={{ flexBasis: '33.33%' }}><Skeleton /></Typography>
                                    </AccordionSummary>
                                </Accordion>
                            ))}
                            {!waits && categories.length == 0 &&
                                <Typography>There are no services available for booking online.</Typography>
                            }
                            {!waits && categories.length > 0 &&
                                _.sortBy(categories, ['name']).map((category) => {
                                    const filteredServices = services.filter((service) => {
                                        if (service.category_id != category.id) {
                                            return false
                                        }

                                        if (!filterTerm.length) {
                                            return true
                                        }

                                        return service.name.match(filterPattern)
                                    })

                                    return (
                                        <Accordion key={category.id} defaultExpanded={categories.length == 1}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                <div className={classes.accordionColumn}>
                                                    <Typography className={classes.accordionHeading}>{category.name}</Typography>
                                                </div>
                                                <div className={classes.accordionColumn}>
                                                    <Typography className={classes.accordionSecondaryHeading}>{filteredServices.length} Services</Typography>
                                                </div>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={2}>
                                                    {filteredServices.length == 0 &&
                                                        <Grid item xs={12}>
                                                            <Typography>There are no services in this category available for online booking.</Typography>
                                                        </Grid>
                                                    }
                                                    {filteredServices.length > 0 &&
                                                        _.sortBy(filteredServices, ['name']).map((service) => (
                                                            <Grid item xs={12} key={service.id}>
                                                                <ServiceCard
                                                                    service={service}
                                                                    employees={employees}
                                                                    asRooms={features.treat_employees_as_rooms}
                                                                    onBook={(serviceId, employeeId) => {
                                                                        history.push(`${match.url}/service-${serviceId}/employee-${employeeId}`)
                                                                    }}
                                                                />
                                                            </Grid>
                                                        ))
                                                    }
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    )
                                })
                            }
                        </Box>
                    </Container>
                </Route>

                {/* service abbrev to service id redirect */}
                <Route path={`${path}/findByAbbrev/:serviceAbbrev`} exact render={({ match: subMatch }) => {
                    if (waits > 0) {
                        return null
                    }

                    const { serviceAbbrev } = subMatch.params
                    const service = services.find(service => service.abbrev == serviceAbbrev)

                    history.push(`${match.url}/service-${service.id}/employee-null`)
                }} />

                {/* service / book appointment */}
                <Route path={`${path}/service-:serviceId/employee-:employeeId`} exact render={({ match: subMatch }) => {
                    let { serviceId, employeeId } = subMatch.params

                    // convert string 'null' to null
                    if (employeeId == 'null') {
                        employeeId = null
                    } else {
                        employeeId = parseInt(employeeId)
                    }

                    const employee = employees.find(employee => employee.id == employeeId)
                    const service = services.find(service => service.id == serviceId)
                    const minDate = moment().add(bookOutMin, 'days')
                    const maxDate = moment().add(bookOutMax, 'days')
                    const displayWeekStart = moment(selectedWeek || minDate).startOf('week')
                    const displayWeekEnd = moment(displayWeekStart).endOf('week')
                    const prevWeekStart = moment(displayWeekStart).subtract(1, 'weeks')
                    const prevWeekEnd = moment(prevWeekStart).endOf('week')
                    const nextWeekStart = moment(displayWeekStart).add(1, 'weeks')
                    const nextWeekEnd = moment(nextWeekStart).endOf('week')
                    const canGoBack = displayWeekStart.isAfter(moment(minDate).startOf('week'))
                    const canGoForward = displayWeekStart.isBefore(moment(maxDate).startOf('week'))

                    // date picker
                    if (!date || !time) {
                        return (
                            <Container maxWidth="md">
                                <Paper className={classes.marginAbove}>
                                    <TheStepper activeStep={1} />
                                </Paper>
                                <Grid className={classes.marginAbove} container justifyContent="space-between">
                                    {canGoBack &&
                                        <Button
                                            color="primary"
                                            startIcon={<ArrowBackIcon />}
                                            onClick={() => {
                                                this.setState({
                                                    selectedWeek: prevWeekStart,
                                                })
                                            }}
                                            disabled={!canGoBack}
                                        >
                                            {prevWeekStart.format('MMM D')}-{prevWeekEnd.format(prevWeekStart.isSame(prevWeekEnd, 'month') ? 'D' : 'MMM D')}
                                        </Button>
                                    }
                                    <Button>
                                        {!canGoBack && 'Week of '}
                                        {displayWeekStart.format('MMM D')}-{displayWeekEnd.format(displayWeekStart.isSame(displayWeekEnd, 'month') ? 'D' : 'MMM D')}
                                    </Button>
                                    {canGoForward &&
                                        <Button
                                            color="primary"
                                            endIcon={<ArrowForwardIcon />}
                                            onClick={() => {
                                                this.setState({
                                                    selectedWeek: nextWeekStart,
                                                })
                                            }}
                                            disabled={!canGoForward}
                                        >
                                            {nextWeekStart.format('MMM D')}-{nextWeekEnd.format(nextWeekStart.isSame(nextWeekEnd, 'month') ? 'D' : 'MMM D')}
                                        </Button>
                                    }
                                </Grid>
                                <Card className={classes.marginAbove}>
                                    <AppointmentPicker
                                        containerClass={classes.appointmentPickerContainer}
                                        serviceId={serviceId}
                                        employeeId={employeeId}
                                        displayWeekStart={displayWeekStart}
                                        hideUnavailableTimes={hideUnavailableTimes}
                                        onSlotClick={(date, time) => {
                                            this.setState({
                                                date,
                                                time,
                                            })

                                            document.documentElement.scrollTop = 0

                                            messageCompanion({
                                                notifyEvent: 'pageChange',
                                            })
                                        }}
                                    />
                                </Card>
                                <Grid className={classes.marginAbove} container justifyContent="space-between">
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            history.push(match.url)
                                        }}
                                    >
                                        Back
                                    </Button>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color="primary"
                                                checked={hideUnavailableTimes}
                                                onClick={this.handleHideUnavailableTimes}
                                            />
                                        }
                                        label="Hide Unavailable Times"
                                    />
                                </Grid>
                            </Container>
                        )
                    }

                    // get guest info
                    if (date && time && user.isGuest && !guestFormFilled) {
                        const customOptionals = {
                            williams: ['street1', 'city', 'state', 'zip'],
                            WylieBusinessSystem: ['phone', 'street1', 'state', 'zip'],
                        }

                        const optionals = customOptionals[fileset] || undefined

                        return (
                            <Container maxWidth="md">
                                <Paper className={classes.marginAbove}>
                                    <TheStepper activeStep={2} />
                                </Paper>
                                <Card className={`${classes.marginAbove} ${classes.guestInfoCard}`}>
                                    <Typography variant="h5">Your Information</Typography>
                                    <GuestForm
                                        className={classes.marginAbove}
                                        defaults={guestInfo}
                                        optionals={optionals}
                                        onSubmit={this.handleGuestFormSubmit}
                                    >
                                        {campaignTypes.length > 0 &&
                                            <Grid item xs={12}>
                                                <TextField
                                                    SelectProps={iframeFixes.Select}
                                                    select={true}
                                                    id="campaignType"
                                                    name="campaignType"
                                                    label="How did you hear about us?"
                                                    variant="outlined"
                                                    autoComplete="campaignType"
                                                    required={!!requireCampaignType}
                                                    fullWidth
                                                    defaultValue=""
                                                >
                                                    {campaignTypes?.map(campaignType => (
                                                        <MenuItem key={campaignType.name} value={campaignType.name}>{campaignType.name}</MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                        }

                                        <Grid item container justifyContent="space-between">
                                            <Button
                                                variant="contained"
                                                onClick={() => {
                                                    document.documentElement.scrollTop = 0

                                                    messageCompanion({
                                                        notifyEvent: 'pageChange',
                                                    })

                                                    this.setState({
                                                        date: null,
                                                        time: null,
                                                    })
                                                }}
                                            >
                                                Back
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                            >
                                                Next
                                            </Button>
                                        </Grid>
                                    </GuestForm>
                                </Card>
                            </Container>
                        )
                    }

                    // submit
                    if (date && time) {
                        const dateFormatted = moment(date, 'Y-MM-DD').format('dddd MMMM Do YYYY')
                        const localTimeFormatted = moment.tz(time, 'HH:mm', store.timezone).tz(localTimeZone).format('h:mm A z')

                        return (
                            <Container maxWidth="md">
                                <Paper className={classes.marginAbove}>
                                    <TheStepper activeStep={2} />
                                </Paper>
                                <Card className={classes.marginAbove}>
                                    <TableContainer className={classes.tableContainer}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={2}>
                                                        <Typography variant="h5">Appointment Details</Typography>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <Box fontWeight="fontWeightBold">Service</Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        {service.name}
                                                    </TableCell>
                                                </TableRow>
                                                {!!employee &&
                                                    <TableRow>
                                                        <TableCell>
                                                            <Box fontWeight="fontWeightBold">{features.treat_employees_as_rooms ? 'Room': 'Employee'}</Box>
                                                        </TableCell>
                                                        <TableCell>
                                                            {employee.first_name} {employee.last_name}
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                                <TableRow>
                                                    <TableCell>
                                                        <Box fontWeight="fontWeightBold">Fee</Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        ${service.price} {user.isEmployee ? '' : service.price == 0 ? '' : service.service_payment_in_advance == 1 ? '(due now)' : '(paid in-clinic)'}
                                                    </TableCell>
                                                </TableRow>
                                                {service.service_payment_in_advance == 2 &&
                                                    <TableRow>
                                                        <TableCell>
                                                            <Box fontWeight="fontWeightBold">Deposit</Box>
                                                        </TableCell>
                                                        <TableCell>
                                                            ${service.service_deposit} (due now)
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                                {service.service_payment_in_advance > 0 && <>
                                                    <TableRow>
                                                        <TableCell className={paymentMethod == 'credit' && !paymentToken ? classes.noBorderBottom : undefined}>
                                                            <Box fontWeight="fontWeightBold">Payment {user.isEmployee ? '(optional)' : ''}</Box>
                                                        </TableCell>
                                                        <TableCell className={paymentMethod == 'credit' && !paymentToken ? classes.noBorderBottom : undefined}>
                                                            <RadioGroup className={classes.radioGroup} value={paymentMethod} onChange={(e) => this.handlePaymentMethodChange(e)} >
                                                                {user.isGuest && <>
                                                                    {cart.onlinePaymentEnabled && <>
                                                                        <FormControlLabel
                                                                            value="credit"
                                                                            control={<Radio />}
                                                                            label={`Credit card ${service.service_payment_in_advance == 3 ? '(required)' : ''}`}
                                                                            disabled={!cart.processorSettings}
                                                                        />
                                                                        {!!paymentToken &&
                                                                            <CreditCardFrame
                                                                                processor={features.payment}
                                                                                locked={true}
                                                                                last4={paymentLast4}
                                                                                onChangeCard={this.handlePaymentChangeCard}
                                                                            />
                                                                        }
                                                                    </>}
                                                                </>}
                                                                {!user.isGuest && <>
                                                                    {user.isEmployee &&
                                                                        <FormControlLabel value="" control={<Radio />} label="None" />
                                                                    }
                                                                    {cart.onlinePaymentEnabled && !!cart.cardsOnFile.length &&
                                                                        <FormControlLabel value="cof" control={<Radio />} label="Saved credit card" />
                                                                    }
                                                                    {paymentMethod == 'cof' &&
                                                                        <RadioGroup className={classes.nested} value={paymentCofId} onChange={(e) => this.handlePaymentCofIdChange(e)} >
                                                                            {cart.cardsOnFile.map(card => (
                                                                                <FormControlLabel key={card.id} value={card.id} control={<Radio />} label={`${card.card_number} / ${card.expiry_date}`} />
                                                                            ))}
                                                                        </RadioGroup>
                                                                    }
                                                                    {cart.onlinePaymentEnabled && <>
                                                                        <FormControlLabel
                                                                            value="credit"
                                                                            control={<Radio />}
                                                                            label={!cart.cardsOnFile.length ? (`Credit card ${service.service_payment_in_advance == 3 ? '(required)' : ''}`) : 'New credit card'}
                                                                            disabled={!cart.processorSettings}
                                                                        />
                                                                        {!!paymentToken &&
                                                                            <CreditCardFrame
                                                                                processor={features.payment}
                                                                                locked={true}
                                                                                last4={paymentLast4}
                                                                                onChangeCard={this.handlePaymentChangeCard}
                                                                            />
                                                                        }
                                                                    </>}
                                                                </>}
                                                            </RadioGroup>
                                                            {service.service_payment_in_advance == 3 &&
                                                                <p>Note: Your card will not be charged at this time.</p>
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                    {cart.onlinePaymentEnabled && paymentMethod == 'credit' && !paymentToken &&
                                                        <TableRow>
                                                            <Hidden mdDown>
                                                                <TableCell />
                                                            </Hidden>
                                                            <TableCell colSpan={2}>
                                                                <CreditCardFrame
                                                                    processor={features.payment}
                                                                    processorSettings={cart.processorSettings}
                                                                    locked={false}
                                                                    last4={paymentLast4}
                                                                    billTo={user.isGuest ? {
                                                                        name: `${guestInfo.firstName} ${guestInfo.lastName}`,
                                                                        email: guestInfo.email,
                                                                        phone: guestInfo.phone,
                                                                        street1: guestInfo.street1,
                                                                        street2: guestInfo.street2,
                                                                        city: guestInfo.city,
                                                                        state: guestInfo.state,
                                                                        zip: guestInfo.zip,
                                                                    } : {
                                                                        name: `${cart.customer?.first_name || ''} ${cart.customer.last_name || ''}`,
                                                                        email: cart.customer?.email_address,
                                                                        phone: cart.customer?.phone_number,
                                                                        street1: cart.customer?.address,
                                                                        street2: cart.customer?.address2,
                                                                        city: cart.customer?.city,
                                                                        state: cart.customer?.province,
                                                                        zip: cart.customer?.postal,
                                                                    }}
                                                                    paymentSaveCard={paymentSaveCard}
                                                                    forceSaveCard={service.service_payment_in_advance == 3}
                                                                    saveCardLabel={service.service_payment_in_advance == 3 ? 'Save card on file (required)' : undefined}
                                                                    onTokenize={this.handleTokenize}
                                                                    onChangeCard={this.handlePaymentChangeCard}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    }
                                                </>}
                                                <TableRow>
                                                    <TableCell>
                                                        <Box fontWeight="fontWeightBold">Time</Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        {dateFormatted} at {localTimeFormatted}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <Box fontWeight="fontWeightBold">Note</Box>
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            label="Note to clinic (optional)"
                                                            variant="outlined"
                                                            fullWidth
                                                            multiline
                                                            value={note}
                                                            onInput={(e) => { this.setState({ note: e.target.value }) }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <CardActions>
                                        <Grid container justifyContent="space-between">
                                            <Button
                                                variant="contained"
                                                onClick={() => {
                                                    document.documentElement.scrollTop = 0

                                                    messageCompanion({
                                                        notifyEvent: 'pageChange',
                                                    })

                                                    if (user.isGuest) {
                                                        this.setState({
                                                            guestFormFilled: false,
                                                            note: '',
                                                        })
                                                    } else {
                                                        this.setState({
                                                            date: null,
                                                            time: null,
                                                            note: '',
                                                        })
                                                    }
                                                }}
                                            >
                                                Back
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                startIcon={<EventAvailableIcon />}
                                                onClick={() => { this.handleBook(serviceId, employeeId, date, time, guestInfo, note) }}
                                                disabled={!this.isSubmittable(service)}
                                            >
                                                Submit
                                            </Button>
                                        </Grid>
                                    </CardActions>
                                </Card>

                                <Dialog open={submitting}>
                                    <Typography className={classes.dialogText}>Submitting request, please wait...</Typography>
                                </Dialog>
                            </Container>
                        )
                    }
                }} />

                {/* 404 Not Found */}
                <Route>
                    <NotFound homePath={paths.root} />
                </Route>
            </Switch>
        )
    }
}

export default withAppContext(withRouter(withStyles(styles, { withTheme: true })(Book)))

function TheStepper(props) {
    return (
        <Stepper {...props} style={{ padding: 16 }}>
            <Step>
                <StepLabel>Choose service</StepLabel>
            </Step>
            <Step>
                <StepLabel>Choose time</StepLabel>
            </Step>
            <Step>
                <StepLabel>Submit</StepLabel>
            </Step>
        </Stepper>
    )
}
